<template>
    <div class="custom-select" :tabindex="tabindex" @blur="open = false">
        <div class="selected" :class="{ open: open, active: active }" @click="open = !open">
            {{ selected }}
        </div>
        <div class="items" :class="{ selectHide: !open }">
            <div
                v-for="(option, i) of myOptions"
                :key="i"
                @click="selectHandler(option)"
                :class="{ selectedItem: option.id == value }"
            >
                {{ option.name }}
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from "../../eventbus";

export default {
    props: {
        options: {
            type: Array,
            required: true,
        },
        defaultOption: {
            type: Object,
            required: false,
            default: null,
        },
        hideSelected: {
            type: Boolean,
            required: false,
            default: true,
        },
        tabindex: {
            type: Number,
            required: false,
            default: 0,
        },
    },
    data() {
        return {
            open: false,
            value: 0,
            active: false
        };
    },
    mounted(){
        EventBus.$on('resetFilters', this.reset);
    },
    methods: {
        selectHandler(option) {
            if (this.value==option.id) {
                this.selected = this.defaultOption;
                this.value = 0;
                this.open = false;
                this.$emit('input', this.value);
                return;
            }
            this.selected = option.name;
            this.value = option.id;
            this.open = false;
            this.$emit('input', option.id);
        },
        reset() {
            this.selected = this.defaultOption ? this.defaultOption.name : (this.options.length > 0 ? this.options[0] : null);// duplicated from data
            this.value = 0;
            this.open = false;
        },
    },
    computed: {
        myOptions(){
            let allOptions = [ this.defaultOption, ...this.options];

            if (!this.hideSelected) return this.options;

            return allOptions.filter((option) => option.name!=this.selected);
        },

        selected() {
            return this.defaultOption ? this.defaultOption.name : (this.options.length > 0 ? this.options[0] : null);
        }
    },
    watch: {
        value(){
            this.active = (this.value >0);
        }
    },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables';
@import '../../styles/classes';

.custom-select {
    position: relative;
    width: 100%;
    outline: none;
    height: 45px;
    line-height: 45px;
    text-align: center;
    text-transform: capitalize;

    .selected {
        background-color: var(--pallete_main_color);
        /*border-radius: 25px;*/
        border: 1px solid var(--pallete_main_color);
        color: #fff;
        cursor: pointer;
        user-select: none;

        &.open {
            border: 1px solid var(--pallete_main_color);
            /*border-radius: 25px 25px 0 0;*/
            border-bottom-color: #0a0a0a;
        }

        &.active {
            background: transparent;
        }

        &:after {
            position: absolute;
            content: "";
            top: 22px;
            right: 1em;
            width: 0;
            height: 0;
            border: 7px solid;
            border-color: #fff transparent transparent transparent;
        }
    }

    .items {
        color: var(--pallete_main_color);
        /*border-radius: 0 0 25px 25px;*/
        overflow: hidden;
        border-right: 1px solid var(--pallete_main_color);
        border-left: 1px solid var(--pallete_main_color);
        border-bottom: 1px solid var(--pallete_main_color);
        position: absolute;
        background-color: var(--background_02);
        left: 0;
        right: 0;
        z-index: 2;

        div {
            cursor: pointer;
            user-select: none;

            &:hover {
                color: var(--pallete_over_main_text_color);
                background-color: var(--pallete_main_color);
            }
            
            &.selectedItem {
                color: var(--pallete_over_main_text_color);
                background-color: var(--pallete_main_color);

                &:hover {
                    background-color: transparent;
                }
            }
        }
    }
}

.selectHide {
    display: none;
}
</style>
